import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { ClienteCadastroModule } from '../../cadastro';
import { ClienteSituacaoModule } from '../../situacao';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { ClienteCentralCompraTypeaheadComponent } from './cliente-central-compra-typeahead.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteCadastroModule,
        ClienteSituacaoModule,
        TypeaheadModule.forRoot()
    ],
    declarations: [
        ClienteCentralCompraTypeaheadComponent
    ],
    exports: [
        ClienteCentralCompraTypeaheadComponent
    ]
})
export class ClienteCentralCompraTypeaheadModule { }
